import React from 'react';
import {BaseIconProps} from '../../types';

export const BaseHome: React.FC<BaseIconProps> = ({color, size}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.2356 8.54136L12 3L2.7644 8.54136C2.34825 8.79105 2.22528 9.33791 2.49448 9.74172L2.54675 9.82012L1.29867 10.6522L1.24641 10.5738C0.502133 9.45736 0.842115 7.94545 1.99266 7.25512L11.2283 1.71376C11.7033 1.42875 12.2967 1.42875 12.7717 1.71376L22.0073 7.25512C23.1579 7.94545 23.4979 9.45737 22.7536 10.5738L22.7013 10.6522L21.4533 9.82012L21.5055 9.74172C21.7747 9.33791 21.6518 8.79105 21.2356 8.54136ZM20.5 11.6862C21.3424 11.7743 22.2015 11.402 22.7013 10.6522L21.4533 9.82012C21.2411 10.1383 20.8502 10.2685 20.5 10.1624C20.4322 10.1419 20.3659 10.1125 20.3028 10.0739L19 9.27778L12 5L5 9.27777L3.69722 10.0739C3.63637 10.1111 3.57263 10.1397 3.50743 10.1602C3.50495 10.1609 3.50248 10.1617 3.5 10.1624C3.14976 10.2685 2.75886 10.1383 2.54675 9.82012L1.29867 10.6522C1.79854 11.402 2.65758 11.7743 3.5 11.6862V20C3.5 20.8284 4.17157 21.5 5 21.5H9C9.82843 21.5 10.5 20.8284 10.5 20V16.5H13.5V20C13.5 20.8284 14.1716 21.5 15 21.5H19C19.8284 21.5 20.5 20.8284 20.5 20V11.6862ZM19 11.0357L12 6.75792L5 11.0357V20H9V15H15V20H19V11.0357Z"
        fill={color}
      />
    </svg>
  );
};
